import MainContainer from "../../components/container/MainContainer";

const Vendor = () => {
  return (
    <MainContainer>
      <div className="flex items-center justify-between my-3">
        <h4 className="">Vendors</h4>
      </div>
      <main className="table-container">
        <div className="w-full h-full flex justify-center items-center">
          <h4 className="text-text-1/60">No Vendors Added yet... </h4>
        </div>
      </main>
    </MainContainer>
  );
};

export default Vendor;
